export const COMPANY_PROFILE_MODALS = {
  deleteCompany: 'deleteCompany',
  transferEmployees: 'transferEmployees',
};

export const DEFAULT_COMPANY_TO_DELETE = { _id: '', name: '' };
